<template>
  <div class="password-change">
    <div class="form-group row"
         :class="{ 'invalid': password_change_form.data.old_password !== null && $v.password_change_form.data.old_password.$invalid }">
      <label for="old_password" class="col-form-label col-2 d-flex align-items-center">
        {{$t('account.old_password')}}
      </label>

      <div class="col-4">
        <input id="old_password"
               type="password"
               class="form-control"
               v-model="password_change_form.data.old_password">
      </div>
    </div>

    <div class="form-group row"
         :class="{ 'invalid': password_change_form.data.new_password !== null && $v.password_change_form.data.new_password.$invalid }">
      <label for="new_password" class="col-form-label col-2 d-flex align-items-center">
        {{$t('account.new_password')}}
      </label>

      <div class="col-4">
        <input id="new_password"
               type="password"
               class="form-control"
               v-model="password_change_form.data.new_password">
      </div>
    </div>

    <div class="form-group row"
         :class="{ 'invalid': password_change_form.data.confirm_password !== null && $v.password_change_form.data.confirm_password.$invalid }">
      <label for="confirm_password" class="col-form-label col-2 d-flex align-items-center">
        {{$t('account.repeat_password')}}
      </label>

      <div class="col-4">
        <input id="confirm_password"
               type="password"
               class="form-control"
               v-model="password_change_form.data.confirm_password">
      </div>
    </div>

    <div v-if='password_change_form.data.confirm_password !== null&& !$v.password_change_form.data.confirm_password.sameAs'
         class="alert alert-success" role="alert">
      {{$t('account.mismatch_passwords')}}
    </div>

    <div v-if='mismatchPassword' class="alert alert-danger" role="alert">
      {{$t('account.old_password_mismatch')}}
    </div>

    <div v-if='password_change_form.success' class="alert alert-success" role="alert">
      {{$t('account.success_password')}}
    </div>

    <div class="row">
      <div class="button-col offset-2 col-4">
        <button :disabled="$v.password_change_form.$invalid || sending"
                @click="changePassword"
                class="btn btn-save w-100">
          {{$t('buttons.save')}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {maxLength, minLength, required, sameAs} from 'vuelidate/lib/validators';
import changePassword from "@/api/user/changePassword";

export default {
  name: 'password-change',
  data() {
    return {
      password_change_form: {
        data: {
          old_password: null,
          new_password: null,
          confirm_password: null,
        }
      },
      mismatchPassword:false,
      sending:false
    };
  },
  methods: {
    changePassword() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return false
      }
      this.sending = true
      changePassword(this.password_change_form.data).then(()=>{
        this.sending = false
        this.password_change_form.success = true
      }).catch((err) =>{
        if(err.response.data.code === 'user-password-mismatch-exception'){
          this.mismatchPassword = true
          setTimeout(()=>
          {
            this.mismatchPassword = false;
            this.sending = false
            this.old_password = null
          },5000)
        }
      })
    },
  },
  validations() {
    return {
      password_change_form: {
        data: {
          old_password: {
            required,
            maxLength: maxLength(64),
          },
          new_password: {
            required,
            minLength: minLength(8),
            maxLength: maxLength(64),
          },
          confirm_password: {
            required,
            sameAs: sameAs('new_password'),
          },
        },
      },
    };
  },
}
</script>

<style lang="scss">
.password-change {
  padding-top: 30px;

  & > .row {
    margin-bottom: 15px;

    &:last-child {
      margin-top: 20px;
    }
  }
}
</style>
